"use client";

var __jsx = React.createElement;
import React from "react";
import { IconButton } from "@modules/shared/components/buttons";
import Icons from "@modules/icons";
import { useCustomer } from "@lib/context/shared/customer-context";
import { useLanguageConfig } from "@lib/context/shared/lang-context";
import { useTranslations } from "next-intl";
import LanguageCurrencyConfigModal from "@modules/layout/components/shared/lang-currency-config-modal";
import useCssModules from "@lib/hooks/use-css-modules";
const HeaderConfigButtons = () => {
  const tLanguage = useTranslations("Shared.LangCurrencyConfig");
  const [configModalIsOpen, setConfigModalIsOpen] = React.useState(false);
  const {
    currentLanguageCode,
    getLanguageOptions
  } = useLanguageConfig();
  const {
    customerIsLogged
  } = useCustomer();
  const {
    cssModules
  } = useCssModules();
  const {
    headerLanguageConfigButtonClassNames,
    headerCurrencyConfigButtonClassNames
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.account.header) || {};
  return __jsx(React.Fragment, null, __jsx("div", {
    className: "flex flex-row gap-2 w-fit",
    onClick: () => setConfigModalIsOpen(true)
  }, getLanguageOptions().length > 1 && __jsx(IconButton, {
    icon: __jsx(Icons.globe, {
      className: headerLanguageConfigButtonClassNames
    }),
    className: ""
  }), __jsx("div", {
    className: "flex items-center"
  }, __jsx(IconButton, {
    icon: __jsx(Icons.currencies, {
      className: headerCurrencyConfigButtonClassNames
    })
  }), __jsx(IconButton, {
    icon: __jsx(Icons.chevronDown, {
      className: headerCurrencyConfigButtonClassNames
    })
  }))), __jsx(LanguageCurrencyConfigModal, {
    isOpen: configModalIsOpen,
    setIsOpen: setConfigModalIsOpen
  }));
};
export default HeaderConfigButtons;